import React from 'react';

import { Button } from 'components/shared/Button';
import { Icon } from 'components/shared/Icon';

import { Modules } from '../Modules';

import { getTranslation } from 'helpers/getTranslation';

import styles from './ModulesSettings.module.scss';

const ModulesSettings = ({
  courseReadOnly,
  modules,
  courseType,
  onAddModuleClick,
  onRemoveModuleClick,
  onEditLessonClick,
  onRemoveLessonClick,
}: {
  courseReadOnly: any;
  modules: any;
  courseType: any;
  onAddModuleClick: any;
  onRemoveModuleClick: any;
  onEditLessonClick: any;
  onRemoveLessonClick: any;
}) => (
  <div className={styles.settings}>
    <Modules
      courseReadOnly={courseReadOnly}
      modules={modules}
      courseType={courseType}
      onRemoveModuleClick={onRemoveModuleClick}
      onEditLessonClick={onEditLessonClick}
      onRemoveLessonClick={onRemoveLessonClick}
    />
    {!courseReadOnly && (
      <Button
        className={styles.button}
        size="md"
        variant="link"
        startIcon={<Icon name="plus" />}
        onClick={onAddModuleClick}
      >
        {getTranslation('common.button.add_module')}
      </Button>
    )}
  </div>
);

export default React.memo(ModulesSettings) as any;
